import { render, staticRenderFns } from "./zbpt.vue?vue&type=template&id=3f3fc868&scoped=true&"
import script from "./zbpt.vue?vue&type=script&lang=js&"
export * from "./zbpt.vue?vue&type=script&lang=js&"
import style0 from "./zbpt.vue?vue&type=style&index=0&id=3f3fc868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3fc868",
  null
  
)

export default component.exports